// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"81ef733c","453":"b96e03c4","937":"f79295c4"}[chunkId] + ".chunk.js";
};